import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    private readonly redirectAfterLogin: string = '/home';
    public loading: boolean = false;
    public data: any = {
        login_id: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = this.redirectAfterLogin;
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        if (this.loading) return;

        let payload = JSON.parse(JSON.stringify(this.data));
        payload.login_id = (payload.login_id || '').trim();

        if (!payload.login_id) {
            await this.alert('아이디를 입력해주세요.');
            return;
        }
        if (!payload.password) {
            await this.alert('비밀번호를 입력해주세요.');
            return;
        }

        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call('login', payload);
        this.loading = false;

        if (code == 200) {
            location.href = this.redirectAfterLogin;
            return;
        }

        await this.alert((data && data.message) || '로그인에 실패했습니다.');
        await this.service.render();
    }
}

export default PageAccessComponent;